module.exports = __webpack_public_path__ + "img/logo1.192f40b2.png";